export default "__VITE_ASSET__YNQocdvO__"